import script from "./tgSearchWindow.vue?vue&type=script&lang=ts&setup=true"
export * from "./tgSearchWindow.vue?vue&type=script&lang=ts&setup=true"

import "./tgSearchWindow.vue?vue&type=style&index=0&id=32f3fad3&scoped=true&lang=css"

import exportComponent from "/Users/ra1to/Desktop/web_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32f3fad3"]])

export default __exports__